import React from "react";

// All pages that rely on 3rd party components (other than Material-UI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";

// Auth components
import ResetPassword from "./pages/auth/ResetPassword";
import UpdatePassword from "./pages/auth/UpdatePassword";
import Page404 from "./pages/auth/Page404";

// Page components

// Protected routes
import RequestJob from "./pages/jobs/RequestJob";
import ApproveJob from "./pages/jobs/ApproveJob";
import AddPlate from "./pages/plates/AddPlate";
import AddBrand from "./pages/plates/AddBrand";
import ApCompany from "./pages/Register/ApCompany";
import ApUser from "./pages/Register/ApUser";
import CustomerUser from "./pages/Register/CustomerUser";
import CustomerCompany from "./pages/Register/CustomerCompany";
import JobDetails from "./pages/jobs/JobDetails";
import AllJobs from "./pages/jobs/AllJobs";
import PlateDetails from "./pages/plates/PlateDetails";
import ApCompanyProfile from "./pages/profile/ApCompanyProfile";
import CustomerCompanyProfile from "./pages/profile/CustomercompanyProfile";
import ApUserProfile from "./pages/profile/ApUserProfile";
import CustomerUserProfile from "./pages/profile/CustomerUserProfile";
import CreateRole from "./pages/roles/createRole";
import Inventory from "./pages/plates/Inventory";
import GlobalInventory from "./pages/plates/GlobalInventory";

import Chalan from "./pages/chalan/Chalan";
import Bills from "./pages/bills/Bills";
import ApCompanies from "./pages/company/ApCompanies";
import CustomerCompanies from "./pages/company/CustomerCompanies";
import ApUsers from "./pages/users/ApUsers";
import CustomerUsers from "./pages/users/CustomerUsers";
import ViewRole from "./pages/roles/ViewRole";
import EditRole from "./pages/roles/EditRole";
import RequestedJobs from "./pages/jobs/RequestedJobs";
import CreateJob from "./pages/jobs/createJob";
import Login from "./pages/auth/Login";
import AdminLogin from "./pages/auth/AdminLogin";
import ApUserLogin from "./pages/auth/ApUserLogin";
import AddTechnology from "./pages/plates/AddTechnology";
import CreateChalan from "./pages/chalan/CreateChalan";
import ChalanDetails from "./pages/chalan/chalanDetails";
import ViewBrands from "./pages/brand/viewBrands";
import ViewTechnology from "./pages/technology/viewTechnology";
import CreateBill from "./pages/bills/createBill";
import CreateTask from "./pages/tasks/createTask";
import UpdateTask from "./pages/tasks/updateTask";
import ViewTasks from "./pages/tasks/viewTasks";
import BillDetails from "./pages/bills/BillDetails";
import EditJob from "./pages/jobs/EditJob";
import UpdateChallan from "./pages/chalan/ChallanUpdate";
import UpdateBill from "./pages/bills/UpdateBill";
import UpdateApCompany from "./pages/company/UpdateApCompany";
import UpdateCustomerCompany from "./pages/company/UpdateCustomerCompany";
import UpdateApUser from "./pages/users/UpdateApUser";
import UpdateCustomerUser from "./pages/users/UpdateCustomerUser";
import MyProfile from "./pages/profile/MyProfile";
import UpdateBrand from "./pages/brand/updateBrand";
import UpdateTechnology from "./pages/technology/UpdateTechnology";
import ApDashboard from "./pages/dashboard/ApDashboard";
import UpdatePlate from "./pages/plates/UpdatePlate";
import ViewTask from "./pages/tasks/viewTask";
import InOut from "./pages/plates/InOut";
import CreateInOut from "./pages/plates/CreateInOut";
import ViewInOut from "./pages/plates/ViewInOut";
import ApprovalInOut from "./pages/plates/ApprovalInOut";
import UpdateInOut from "./pages/plates/UpdateInOut";
import Sessions from "./pages/sessions/sessions";
import PastSessionLogs from "./pages/sessions/PastLogs";
import PhysicalStock from "./pages/physicalStock/PhysicalStock";
import UpdatePhysicalStock from "./pages/physicalStock/UpdatePhysicalStock";
import ProductionReport from "./pages/productionReport/ProductionReport";
// import UpdateProductionReport from "./pages/productionReport/CreateProductionReport";
import CreateProductionReport from "./pages/productionReport/CreateProductionReport";
import ViewProductionReport from "./pages/productionReport/ViewProductionReport";
import UpdateProductionReport from "./pages/productionReport/UpdateProductionReport";
import CustomerCompanyPlates from "./pages/company/CustomerCompanyPlates";
import FixedCostList from "./pages/fixedCost/FixedCostList";
import SettingsPage from "./pages/settings/SettingsPage";
import PlatePriceScheduleList from "./pages/effectiveCost/PlatePriceScheduleList";
import PlatePriceScheduleCreate from "./pages/effectiveCost/PlatePriceScheduleCreate";
import PlatePriceScheduleEdit from "./pages/effectiveCost/PlatePriceScheduleEdit";
import StockAuditing from "./pages/stockAuditing/StockAuditing";

const routes = [
  {
    path: "dashboard/stats",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["*"],
        path: "",
        element: <ApDashboard />,
      },
    ],
  },
  {
    path: "dashboard/tasks",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["task_operations"],
        path: "",
        element: <ViewTasks />,
      },
      {
        allowedRole: ["task_operations"],
        path: ":task_id",
        element: <ViewTask />,
      },
      {
        allowedRole: ["task_operations"],
        path: "create-task",
        element: <CreateTask />,
      },
      {
        allowedRole: ["task_operations"],
        path: "update-task/:task_id",
        element: <UpdateTask />,
      },
    ],
  },
  {
    path: "profile",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["*"],
        path: "my",
        element: <MyProfile />,
      },
    ],
  },
  {
    path: "dashboard/jobs",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["request_new_job"],
        path: "request",
        notAllowed: true,
        element: <RequestJob />,
      },
      {
        allowedRole: ["approve_requested_job"],
        path: "approve",
        element: <ApproveJob />,
      },
      {
        allowedRole: ["approve_requested_job"],
        path: "requested-jobs",
        element: <RequestedJobs />,
      },
      {
        allowedRole: [
          "view_jobs_list",
          "view_all_job_list",
          "view_only_assigned_job_list",
        ],
        path: "",
        element: <AllJobs />,
      },
      {
        allowedRole: ["create_new_job"],
        path: "create-job/",
        element: <CreateJob />,
      },
      {
        allowedRole: ["create_new_job"],
        path: "create-job/:job_id",
        element: <CreateJob />,
      },

      {
        allowedRole: ["view_job_details"],
        path: "job-details/:job_id",
        element: <JobDetails />,
      },
      {
        allowedRole: ["edit_job_details"],
        path: "edit-job/:job_id",
        element: <EditJob />,
      },
    ],
  },
  {
    path: "dashboard/sessions",
    element: <DashboardLayout />,

    children: [
      {
        path: "",
        element: <Sessions />,
        allowedRole: ["super_admin"],
      },
    ],
  },
  {
    path: "dashboard/sessions/logs",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <PastSessionLogs />,
        allowedRole: ["super_admin"],
      },
    ],
  },
  {
    path: "dashboard/production-report",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <ProductionReport />,
        allowedRole: ["super_admin", "view_dpr"],
      },
      {
        path: "view/:production_id",
        element: <ViewProductionReport />,
        allowedRole: ["super_admin", "view_dpr"],
      },
      {
        path: "create",
        element: <CreateProductionReport />,
        allowedRole: ["create_dpr"],
      },
      {
        path: "edit/:production_id",
        element: <UpdateProductionReport />,
        allowedRole: ["update_dpr"],
      },
      // {
      //   path: "update",
      //   element: <UpdateProductionReport />,
      //   allowedRole: ["super_admin","update_dpr"],
      // },
    ],
  },
  // {
  //   path: "dashboard/inventory/physical-stock",
  //   element: <DashboardLayout />,
  //   children: [
  //     {
  //       path: "",
  //       element: <PhysicalStock />,
  //       allowedRole: ["super_admin"],
  //     },
  //     {
  //       path: "update",
  //       element: <UpdatePhysicalStock />,
  //       allowedRole: ["super_admin"],
  //     },
  //   ],
  // },
  {
    path: "dashboard/inventory",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["create_plate"],
        path: "plates",
        element: <AddPlate />,
      },
      {
        allowedRole: ["create_new_brand"],
        path: "brand",
        element: <AddBrand />,
      },
      {
        allowedRole: ["view_brand_list"],
        path: "view-brands",
        element: <ViewBrands />,
      },
      {
        allowedRole: ["create_new_technology"],
        path: "technology",
        element: <AddTechnology />,
      },
      {
        allowedRole: ["view_plate_list"],
        path: "global",
        element: <GlobalInventory />,
      },
      {
        allowedRole: ["view_technology_list"],
        path: "view-technology",
        element: <ViewTechnology />,
      },
      {
        allowedRole: ["view_in_out"],
        path: "in-out",
        children: [
          {
            allowedRole: ["view_in_out"],
            path: "",
            element: <InOut />,
          },
          {
            allowedRole: ["view_in_out"],
            path: ":in_out_id",
            element: <ViewInOut />,
          },
          {
            allowedRole: ["create_in_out"],
            path: "create",
            element: <CreateInOut />,
          },
        ],
      },
      {
        allowedRole: ["super_admin"],
        path: "physical-stock",
        children: [
          {
            allowedRole: ["super_admin"],
            path: "",
            element: <PhysicalStock />,
          },
          {
            allowedRole: ["super_admin"],
            path: "update",
            element: <UpdatePhysicalStock />,
          },
        ],
      },
      {
        allowedRole: ["view_pending_in_out"],
        path: "approval-in-out",
        children: [
          {
            allowedRole: ["view_pending_in_out"],
            path: "",
            element: <ApprovalInOut />,
          },
          {
            allowedRole: ["view_pending_in_out"],
            path: "update-request/:in_out_id",
            element: <UpdateInOut />,
          },

          // {
          //   allowedRole: ["view_in_out"],
          //   path: ":in_out_id",
          //   element: <ViewInOut />,
          // },
          // {
          //   allowedRole: ["create_in_out"],
          //   path: "create",
          //   element: <CreateInOut />,
          // },
        ],
      },
      // {
      //   allowedRole: ['create_in_out'],
      //   path: '',
      //   element: <AddTechnology />,
      // },

      {
        allowedRole: ["view_plate_details"],
        path: "plateDetails/:plate_id",
        element: <PlateDetails />,
      },
      {
        allowedRole: ["view_plate_list"],
        path: "",
        element: <Inventory />,
      },
      {
        allowedRole: ["edit_brand"],
        path: "update-brand",
        element: <UpdateBrand />,
      },
      {
        allowedRole: ["edit_technology"],
        path: "update-technology",
        element: <UpdateTechnology />,
      },
      {
        allowedRole: ["super_admin"],
        path: "update-plate/:plate_id",
        element: <UpdatePlate />,
      },
    ],
  },
  {
    path: "dashboard/challan",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_challan_list"],
        path: "",
        element: <Chalan />,
      },
      {
        allowedRole: ["create_challan"],
        path: "create-challan",
        element: <CreateChalan />,
      },
      {
        allowedRole: ["view_challan_details"],
        path: "challan-details/:challan_id",
        element: <ChalanDetails />,
      },
      {
        allowedRole: ["update_challan_details"],
        path: "update-challan/:challan_id",
        element: <UpdateChallan />,
      },
    ],
  },
  {
    path: "dashboard/bill",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["create_bill"],
        path: "create-bill",
        element: <CreateBill />,
      },
      {
        allowedRole: ["view_bill_list"],
        path: "",
        element: <Bills />,
      },
      {
        allowedRole: ["view_bill_details"],
        path: "bill-details/:bill_id",
        element: <BillDetails />,
      },
      {
        allowedRole: ["update_bill_details"],
        path: "update-bill/:bill_id",
        element: <UpdateBill />,
      },
    ],
  },
  {
    path: "dashboard/company",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_customer_company_list"],
        path: "customer-companies",
        element: <CustomerCompanies />,
      },
      {
        allowedRole: ["view_customer_company_list"],
        path: "customer-companies/plates",
        element: <CustomerCompanyPlates />,
      },
      {
        allowedRole: ["create_customer_company"],
        path: "customer-companies/create-customer-company",
        element: <CustomerCompany />,
      },
      {
        allowedRole: ["view_ap_company_list"],
        path: "ap-companies",
        element: <ApCompanies />,
      },
      {
        allowedRole: ["create_ap_company"],
        path: "ap-companies/create-ap-company",
        element: <ApCompany />,
      },
      {
        allowedRole: ["update_ap_company"],
        path: "ap-companies/update-ap-company/:company_id",
        element: <UpdateApCompany />,
      },
      {
        allowedRole: ["update_customer_company"],
        path: "customer-companies/update-customer-company/:company_id",
        element: <UpdateCustomerCompany />,
      },
    ],
  }, {
    path: "dashboard/settings",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_settings"],
        path: "",
        element: <SettingsPage />,
      },]
  },
  {
    path: "dashboard/fixed-cost",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_fixed_cost_list"],
        path: "",
        element: <FixedCostList />,
      }
    ],
  },
  {
    path: "dashboard/plate-price-schedules",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_plate_price_schedules"],
        path: "",
        element: <PlatePriceScheduleList />,
      },
      {
        allowedRole: ["create_plate_price_schedule"],
        path: "create",
        element: <PlatePriceScheduleCreate />,
      },
      {
        allowedRole: ["edit_plate_price_schedule"],
        path: "edit/:id",
        element: <PlatePriceScheduleEdit />,
      },
    ],
  },
  {
    path: "dashboard/stock-auditing",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_stock_auditing"],
        path: "",
        element: <StockAuditing />,
      },
    ],
  },
  {
    path: "dashboard/roles",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["create_role"],
        path: "create-role",
        element: <CreateRole />,
      },
      {
        allowedRole: ["view_role"],
        path: "",
        element: <ViewRole />,
      },
      {
        allowedRole: ["edit_role"],
        path: "edit-role",
        element: <EditRole />,
      },
    ],
  },
  {
    path: "dashboard",
    element: <DashboardLayout />,
    children: [
      {
        allowedRole: ["view_customer_company_user_profile"],
        path: "users/customer-users/:user_id",
        element: <CustomerUserProfile />,
      },
      {
        allowedRole: ["view_ap_user_profile"],
        path: "users/ap-users/:user_id",
        element: <ApUserProfile />,
      },
      {
        allowedRole: ["view_customer_company_profile"],
        path: "company/customer-companies/:company_id",
        element: <CustomerCompanyProfile />,
      },
      {
        allowedRole: ["view_ap_company_profile"],
        path: "company/ap-companies/:company_id",
        element: <ApCompanyProfile />,
      },
    ],
  },
  {
    path: "dashboard/users",
    element: <DashboardLayout />,
    children: [
      {
        path: "ap-users",
        element: <ApUsers />,
        allowedRole: ["view_ap_user_list"],
      },
      {
        allowedRole: ["create_ap_user"],
        path: "ap-users/add",
        element: <ApUser />,
      },
      {
        path: "customer-users",
        element: <CustomerUsers />,
        allowedRole: ["view_customer_company_user_list"],
      },
      {
        allowedRole: ["create_customer_company_user"],
        path: "customer-users/add",
        element: <CustomerUser />,
      },
      {
        path: "ap-users/update-ap-user/:user_id",
        element: <UpdateApUser />,
        allowedRole: ["update_ap_user"],
      },
      {
        path: "customer-users/update-customer-user/:user_id",
        element: <UpdateCustomerUser />,
        allowedRole: ["update_customer_company_user"],
      },
    ],
  },

  {
    path: "login",
    element: <AuthLayout />,
    children: [
      {
        allowedRole: ["*"],
        path: "",
        element: <Login />,
      },
      {
        allowedRole: ["*"],
        path: "ap-user",
        element: <ApUserLogin />,
      },
      {
        allowedRole: ["*"],
        path: "admin",
        element: <AdminLogin />,
      },
    ],
  },
  {
    path: "reset-password",
    element: <AuthLayout />,
    children: [
      {
        path: "",
        allowedRole: ["*"],
        element: <ResetPassword />,
      },
      {
        path: "update",
        allowedRole: ["*"],
        element: <UpdatePassword />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        allowedRole: ["*"],
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
